import styled from "styled-components";

/**
 * Shared styled-components extracted from the page containers to remove
 * verbatim duplication. Only the pieces that were byte-identical (or share an
 * identical visual "base") live here — per-page spacing/sizing stays in each
 * container so this extraction does not change any page's appearance.
 */

// Full-height flex column with the standard light-gray app background.
// Was duplicated identically across every page container.
export const PageContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--brand-bg-soft);
`;

// The shared gray primary-button look (color, pill radius, hover lift,
// disabled state). Pages compose this with `styled(PrimaryButton)` to add
// their own width/height/padding/margins, e.g.:
//
//   const SubmitButton = styled(PrimaryButton)`
//     width: 100%;
//     height: 52px;
//   `;
export const PrimaryButton = styled.button`
  background: var(--brand-primary);
  color: #fff;
  border: none;
  border-radius: var(--brand-radius);
  font-weight: 600;
  cursor: pointer;
  box-shadow: var(--brand-shadow-primary);
  transition: background 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;

  &:hover:not(:disabled) {
    background: var(--brand-primary-600);
    transform: translateY(-1px);
    box-shadow: var(--brand-shadow-primary-hover);
  }

  &:disabled {
    background: var(--brand-border-strong);
    color: var(--brand-ink-3);
    cursor: not-allowed;
    box-shadow: none;
  }
`;
